import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import has from 'lodash/has'
import username from '../../../lib/username'

/**
 * Determines whether the presenter is dialed-in
 * @param state The Redux state
 */

const getDialedInList = (state: State): string[] => state.room.dialedInParticipants
const getMyBTID = (state: State, props): string => has(props, 'presenter.BTID') ? props.presenter.BTID : state.user.BTID

export function isDialIn (
  dialedInList: string[],
  BTID: string
): boolean {

  return dialedInList.includes(username.getPureUsername(BTID))

}

export default () => createSelector(
  [getDialedInList, getMyBTID],
  (dialedInList, BTID): boolean =>{

    return isDialIn(dialedInList, BTID)
  }

)
